import { Flex, Text } from '@chakra-ui/react'
import React, { useMemo, useState } from 'react'
import IconPlus from '~/assets/svgs/icon-plus.svg?react'
import { useBlockedNumbers } from '~/atoms/BlockedNumbersState'
import { Close } from '~/components/compositional/QuickActions'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { MangoButton } from '~/components/shared/MangoButton'
import { Size } from '~/types/ThemeTypes'
import { formatPhoneNumber } from '~/utils/formatter'

import { useBlockedNumberStyles } from './componentStyles/BlockedNumbers.styles'
import { BlockNumberModal } from './Shared/BlockedNumberModal'

export const BlockedNumbers = () => {
  const {
    blockedNumbers,
    unblockNumber,
    blockNumber,
    isBlocking,
    refetchBlockedNumbers,
  } = useBlockedNumbers({ forceRefresh: true })

  const styles = useBlockedNumberStyles()

  const [isBlockModalOpen, setBlockModalOpen] = useState(false)

  const handleBlockModalOpen = () => {
    setBlockModalOpen(true)
  }

  const handleBlockModalClose = () => {
    setBlockModalOpen(false)
  }

  const blockedNumberContent = useMemo(() => {
    if (blockedNumbers && blockedNumbers.length > 0) {
      return blockedNumbers.map((blockedNumber) => (
        <Flex key={blockedNumber.id} sx={styles.blockedNumberWrapper}>
          <Text sx={styles.blockedNumberText}>
            {formatPhoneNumber(blockedNumber.phoneNumber)}
          </Text>
          <Close
            iconProps={{ boxSize: '0.625rem' }}
            onClick={() => {
              unblockNumber(blockedNumber.id, blockedNumber.phoneNumber)
              refetchBlockedNumbers()
            }}
            size={Size.sm}
            tooltipDisabled={true}
          />
        </Flex>
      ))
    } else {
      return <Text>No blocked numbers found.</Text>
    }
  }, [blockedNumbers])

  return (
    <Flex sx={styles.outerWrapper}>
      <BlockNumberModal
        isOpen={isBlockModalOpen}
        onClose={handleBlockModalClose}
        onBlockNumber={blockNumber}
        isLoading={isBlocking}
      />
      <Flex sx={styles.wrapper}>
        <Flex sx={styles.headerWrapper}>
          <Flex sx={styles.header}>
            <Text sx={styles.headerText}>Blocked Numbers</Text>
            <MangoButton
              variant={MangoButtonVariant.Default_200}
              size={Size.sm}
              leftIcon={IconPlus}
              onClick={handleBlockModalOpen}
            >
              Add Number
            </MangoButton>
          </Flex>
          <Text sx={styles.headerSubtext}>
            All calls, texts, and faxes from the numbers listed below will be
            blocked.
          </Text>
        </Flex>
        <Flex sx={styles.numberWrapper}>{blockedNumberContent}</Flex>
      </Flex>
    </Flex>
  )
}
